import React from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import NotificationBell from '../common/NotificationBell';
import { Toaster } from '../../components/ui/sonner';

const DashboardLayout = ({ children }) => {
  return (
    <div className="min-h-screen bg-[#F8FAFC]">
      <Sidebar />
      <main className="ml-56 min-h-screen">
        {/* Top Header Bar */}
        <div className="sticky top-0 z-30 bg-white/80 backdrop-blur-sm border-b border-gray-100 px-6 py-3 flex justify-end items-center gap-4">
          <NotificationBell />
        </div>
        <div className="p-6">
          {children || <Outlet />}
        </div>
      </main>
      <Toaster position="top-right" richColors />
    </div>
  );
};

export default DashboardLayout;
